export const unitTranslation = {
  hours: 'Hora-uso',
  kilometers: 'Quilometragem',
}

export const unitStrategy = {
  hours: 'H',
  liters: 'L',
  kilometers: 'Km',
}

export const unities: { [key: string]: string}  = {
  liters: 'L',
  kilometers: 'Km',
  hours: 'H',
}
